export const environment = {
    production: false,
    api_url: 'https://api.agm-certificates.agmtest.net:443'
};
